import { render } from "./topup-verification-detail-lazy-load.vue?vue&type=template&id=d9ec9486&ts=true"
import script from "./topup-verification-detail-lazy-load.vue?vue&type=script&lang=ts"
export * from "./topup-verification-detail-lazy-load.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__